import { ChangeLogEntityType, useGetChangeLogByEntity } from '../../../../api/created/changeLog.ts';
import type { AddressDto } from '../../../../api/generated/model';
import { useUsers } from '../../../../api/created/users.ts';
import { ChangeHistoryModal } from '../../../../components/history/ChangeHistoryModal.tsx';
import { mapChangeLogEntriesToInstitutionHistory } from './institutionHistory.ts';

type InstitutionHistoryModalProps = {
  open: boolean;
  onClose: () => void;
  address: AddressDto | null;
};

export function InstitutionHistoryModal({ open, onClose, address }: InstitutionHistoryModalProps) {
  const addressId = address?.id;
  const { data: changeLogEntries = [], isLoading } = useGetChangeLogByEntity(ChangeLogEntityType.ADDRESS, addressId, {
    enabled: open && !!addressId,
  });
  const { data: users = [] } = useUsers({ enabled: open && !!addressId });
  const historyEntries = mapChangeLogEntriesToInstitutionHistory(changeLogEntries, { users });
  const institutionName = address?.organization ?? 'Institution';

  return (
    <ChangeHistoryModal
      open={open}
      onClose={onClose}
      title={`Verlauf – ${institutionName}`}
      subject="Die Institution"
      entityName={institutionName}
      entries={historyEntries.map((entry) => ({
        ...entry,
        changedBy: entry.changedByName,
      }))}
      isLoading={isLoading}
    />
  );
}
